
import Layout from "@/components/Layout";
import PrivacyPolicyContent from "@/components/legal/PrivacyPolicyContent";

const PrivacyPolicyPage = () => {
  return (
    <Layout>
      <PrivacyPolicyContent />
    </Layout>
  );
};

export default PrivacyPolicyPage;
